import React from 'react';
import { Icon } from './Icon.js';
export const IconDots = ({ ...props }) => {
    return (React.createElement(Icon, { size: "24px", ...props },
        React.createElement("path", { d: "M12 11.995L12 11.9951", stroke: "currentColor", strokeWidth: "3", strokeLinecap: "square", "data-color": "color-2", fill: "none" }),
        React.createElement("path", { d: "M19 11.995L19 11.9951", stroke: "currentColor", strokeWidth: "3", strokeLinecap: "square", fill: "none" }),
        React.createElement("path", { d: "M5 11.995L5 11.9951", stroke: "currentColor", strokeWidth: "3", strokeLinecap: "square", fill: "none" })));
};
//# sourceMappingURL=IconDots.js.map